import { Layer, InputX, Logo, Button, NoData } from "components"
import { useEffect } from "react"
import { useRecoilState, useRecoilValue } from 'recoil'
import { searchDataState, searchCountState, searchCheckedCountState } from 'views/data/states.js'
import { showSearchLayerState } from "../states"

const SearchLayer = ({ data, setCheck }) => {

	const [searchData, setSearchData] = useRecoilState(searchDataState)
	const searchedCheckedCount = useRecoilValue(searchCheckedCountState)
	const searchCount = useRecoilValue(searchCountState)
	const [show, setShow] = useRecoilState(showSearchLayerState)

	useEffect(() => {
		setSearchData("")
	}, [show])

	return (
		<Layer show={show} closeLayer={() => setShow(false)} title="기관검색">
			<div className="page">
				<div className="padding flex_1 pb_70 flex-column">
					<div className="form-group search-bar">
						<InputX focus type="text" value={searchData} placeholder="검색어를 입력해주세요." onX={() => setSearchData("")} onChange={e => setSearchData(e.target.value)} />
						<i className="icon icon_search" />
					</div>
					{
						searchCount > 0
							?
							<ul className="check-area mt_40">
								{
									data &&
									data.map((group, index) => {
										if (group.searchedCount > 0) {
											return (
												<Group key={index} group={group} setCheck={setCheck} />
											)
										}
									})
								}
							</ul>
							:
							<NoData text="검색된 기관이 없습니다." />
					}
				</div>
				<div className="button-group">
					<Button className="btn btn--big btn-layer fixed" onClick={() => setShow(false)} style={{ bottom: 0 }}>
						적용 <strong>({searchedCheckedCount})</strong>
					</Button>
				</div>
			</div>
		</Layer>
	)
}

const Group = ({ group, setCheck }) => {
	return (
		<li>
			<div className="check-title">{group.indstNm} <span>{group.searchedCount}</span></div>
			{
				group.data.map((item, index) => {
					if (item.searched) {
						return <Item item={item} key={index} setCheck={setCheck} />
					}
				})
			}
		</li>
	)
}

const Item = ({ item, setCheck }) => {
	return (
		<div className="check-list" onClick={() => setCheck(item.insttCd)}>
			<div>
				<div>
					<div className="img-box img-symbol">
						<Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
					</div>
					<div className="ml_10">
						<p>{item.insttNm}</p>
					</div>
				</div>
				<i className={`checkMark ${item.checked === true ? "on" : ""}`} />
			</div>
		</div>
	)
}

export default SearchLayer